import React, { useEffect, useState } from 'react';
import axios from '../../../api/apiClient';
import { domain, token } from '../../../components/Security';

export const EFFECTIVE_DATE_MSC_HISTORY_CONFIG = {
  apiEndpoint: "/api/MaintenanceSalaryCombinationV2RateHistory/effective-date-group",
  entityName: "MaintenanceSalaryCombinationV2RateHistory",
  idField: "effectiveDate",
  displayFields: {
    primary: "effectiveDate"
  },
  tableHeaders: ["Effective Date"],
  tableAccessors: ["effectiveDate"],
  searchFields: [
    { label: "Effective Date", field: "effectiveDate", index: 0 }
  ],
  placeholder: "--Select effective date--",
  // Important: this picker does not receive normal { id, ... } entities.
  valueType: "primitive"
};

export function EffectiveDateMSCHistoryPickerSelect({
  label,
  value,
  onSelect,
  onClear,
  placeholder = "--Select effective date--",
  allowAll = false,
  disabled = false,
  isRequired = false,
  className = "",
  error = false,
  errorMessage = ""
}) {
  const [effectiveDates, setEffectiveDates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEffectiveDates = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          domain + EFFECTIVE_DATE_MSC_HISTORY_CONFIG.apiEndpoint,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );

        setEffectiveDates(response.data || []);
      } catch (error) {
        console.error("Error fetching MSC history effective dates:", error);

        setEffectiveDates([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEffectiveDates();
  }, []);

  const handleChange = (e) => {
    const selectedValue = e.target.value;

    if (!selectedValue) {
      if (onClear) {
        onClear();
      }

      return;
    }

    if (onSelect) {
      onSelect(selectedValue);
    }
  };

  return (
    <div className="mb-1 w-full">
      {label && (
        <label className="mb-1.5 block text-sm font-medium text-gray-600">
          {label}
          {isRequired && (
            <span className="ml-1 text-red-500">*</span>
          )}
        </label>
      )}

      <div className={error ? "rounded-md ring-1 ring-red-500" : ""}>
        <select
          value={value || ""}
          disabled={loading || disabled}
          onChange={handleChange}
          className={`
            w-full border border-gray-300 rounded-md px-3 h-[33px]
            transition-all cursor-pointer
            focus:outline-none focus:ring-2 focus:ring-blue-500/20
            focus:border-blue-500
            ${!value
              ? "text-gray-400 font-normal"
              : "text-gray-700 font-medium border-blue-200 bg-blue-50/10"
            }
            ${disabled
              ? "bg-gray-100 cursor-not-allowed opacity-60"
              : "bg-white hover:border-gray-400"
            }
            ${className}
          `}
        >
          <option value="">
            {loading
              ? "Loading..."
              : allowAll
                ? "All"
                : placeholder}
          </option>

          {effectiveDates.map((date) => (
            <option
              key={date}
              value={date}
              className="text-gray-800"
            >
              {date}
            </option>
          ))}
        </select>
      </div>

      {error && (
        <span className="mt-1 block text-sm text-red-500">
          {errorMessage}
        </span>
      )}
    </div>
  );
}

export { EffectiveDateMSCHistoryPickerSelect as default };